export default "__VITE_ASSET__511699ff__"